module.exports = __webpack_public_path__ + "static/media/add-season-01.c3ce0160.png";